import type { Component } from 'vue';
import type { EngineFieldType } from '@record-fill';
import FillCheckboxControl from './controls/FillCheckboxControl.vue';
import FillDateControl from './controls/FillDateControl.vue';
import FillNumberControl from './controls/FillNumberControl.vue';
import FillParagraphControl from './controls/FillParagraphControl.vue';
import FillRadioControl from './controls/FillRadioControl.vue';
import FillRegisterNumberControl from './controls/FillRegisterNumberControl.vue';
import FillSelectControl from './controls/FillSelectControl.vue';
import FillTextControl from './controls/FillTextControl.vue';

// The fill side of the contract: every field type the engine compiles must have a control.
export const FILL_CONTROL_MAP = {
  TEXT_INPUT: FillTextControl,
  PARAGRAPH: FillParagraphControl,
  EMAIL_INPUT: FillTextControl,
  URL_INPUT: FillTextControl,
  REGISTER_NUMBER_INPUT: FillRegisterNumberControl,
  NUMBER_INPUT: FillNumberControl,
  DROPDOWN: FillSelectControl,
  RADIO_GROUP: FillRadioControl,
  CHECKBOX: FillCheckboxControl,
  DATE_INPUT: FillDateControl,
} satisfies Record<EngineFieldType, Component>;
